import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AffiliatePage() {
  const { code } = useParams();

  useEffect(() => {
    if (code) {
      localStorage.setItem('aff_code', code);
      window.location.href = `${API}/affiliate/go/${code}`;
    }
  }, [code]);

  return <div style={{ padding: '2rem', textAlign: 'center' }}>Mengarahkan...</div>;
}
